export default __webpack_public_path__ + "static/media/DSC_0577.f6b924c5.jpg";